import * as Icons from './index.js';
export type ShippingProviderType =
    | 'POSTEN'
    | 'HELTHJEM'
    | 'POSTNORD'
    | 'POSTI'
    | 'DAO'
    | 'GLS'
    | 'MATKAHUOLTO';

export const getShippingProviderLogo = (provider: ShippingProviderType) => {
    switch (provider) {
        case 'POSTEN':
            return <Icons.PostenLogo />; // Finn
        case 'HELTHJEM':
            return <Icons.HelthjemLogo />; // Finn
        case 'POSTNORD':
            return <Icons.PostnordLogo />; // Finn
        case 'POSTI':
            return <Icons.PostiLogo />; // Tori
        case 'MATKAHUOLTO':
            return <Icons.MatkahuoltoLogo />; // Tori
        case 'DAO':
            return <Icons.DAOLogo />; // DBA
        case 'GLS':
            return <Icons.GLSLogo />; // DBA
        default:
            console.error('Could not find an icon for this provider: ', provider);
            return null;
    }
};
